export default __webpack_public_path__ + "static/national-yards-desktop-97f0f0c623f0d9db7abfdc3c45a0e3ee.svg";